import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import injectSheet from 'react-jss';

import {
  START_MENU_DISPLAY_CONTEXT_LOGIN,
  START_MENU_DISPLAY_CONTEXT_SIGNUP,
  START_MENU_DISPLAY_CONTEXT_RECOVER,
} from 'shared/constants/web';
import { GLOBAL_STYLE, OVERLAY_DISPLAY_ATTR } from 'shared/constants/web';
import { BASE_COLOR } from 'shared/constants/colors';
import {
  startMenuDisplayLogin,
  startMenuDisplaySignup,
  startMenuDisplayRecover,
} from 'shared/actions/view/web';
import { compose } from 'shared/helpers';

import { mixClasses as cx } from 'helpers';

import {
  UserLoginForm,
  UserSignupForm,
  UserRecoverForm,
} from 'components/forms';
import { TextButton } from 'components/elems';

const { SUSPEND_NAV_OUT } = OVERLAY_DISPLAY_ATTR;


function mapStateToProps(state) {
  return {overlayViewState: state.view.get('overlay')};
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    startMenuDisplayLogin,
    startMenuDisplaySignup,
    startMenuDisplayRecover,
  }, dispatch);
};


/*
 * StartMenu Component
 */
const StartMenu = ({
  classes: cn,
  displayContext = START_MENU_DISPLAY_CONTEXT_LOGIN,
  ...props
}) => {
  const startMenuContentsMap = {
    [START_MENU_DISPLAY_CONTEXT_LOGIN]: {
      selectLabel: 'Log in',
      selectOnClick: props.startMenuDisplayLogin,
      selectClassName: null,
      form: <UserLoginForm />,
    },
    [START_MENU_DISPLAY_CONTEXT_SIGNUP]: {
      selectLabel: 'Sign up',
      selectOnClick: props.startMenuDisplaySignup,
      selectClassName: null,
      form: <UserSignupForm />,
    },
    [START_MENU_DISPLAY_CONTEXT_RECOVER]: {
      selectLabel: 'Reset password',
      selectOnClick: props.startMenuDisplayRecover,
      selectClassName: 'mt6 f4',
      form: <UserRecoverForm />,
    },
  };

  const overlayDisplayAttrs = props.overlayViewState.get('displayAttrs');
  const shouldSuspendNavOut = overlayDisplayAttrs.includes(SUSPEND_NAV_OUT);

  const startMenuSelectOptions = Object.entries(
    startMenuContentsMap
  ).map(([key, val]) => {
    const isActivated = displayContext === key;

    return (
      <div key={key} className={cx('mb4', val.selectClassName)}>
        <TextButton
          className={'tr fw5 moa-ff-sans'}
          label={val.selectLabel}
          onClick={val.selectOnClick}
          isActivated={isActivated}
          isDisabled={shouldSuspendNavOut && !isActivated}
        />
      </div>
    );
  });

  // 'displayContext' set to null in view reducer initial state, so guard againt that.
  const startMenuForm = (startMenuContentsMap[displayContext] || {}).form;

  return (
    <div className={cx(
      cn.root,
      'flex justify-center h-100 pa5 pv6')}
    >
      <div className={cx(cn.baseWrap, 'w-100 flex')}>

        {/* StartMenu selection */}
        <div className={cx('fl w-30 w-third-l')}>
          <div className={cx('tr h-100 pr4 pr6-l flex flex-column justify-between')}>
            <div className={cx('h-100 pr3 pr4-l br b--black-10 moa-ff-sans f2 f1-l')}>
              {startMenuSelectOptions}
            </div>

            {/*
              Put more links if needed
              <div className={'h-25 pr5 br b--black-10 moa-ff-sans ttu black-70 f5'} />
            */}
          </div>
        </div>

        {/* StartMenu form */}
        <div className={cx(cn.formCon, 'fl w-third moa-ff-sans')}>
          <div className={cx('ph4 ph5-l')}>
            {startMenuForm}
          </div>
        </div>
      </div>
    </div>
  );
};

const styles = {
  root: {
    background: BASE_COLOR.white,
    // XXX: use cn.animateTranslateUpLarge,
    // animation: 'Overlay-translate-up 150ms ease forwards'
  },
  baseWrap: {
    maxWidth: GLOBAL_STYLE.contentMaxWidth,
  },
  formCon: {
    // Seems reasonable. Feeble attempt at responsive design.
    minWidth: '480px',
  },
};


export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  injectSheet(styles)
)(StartMenu);



// WEBPACK FOOTER //
// ./src/components/overlays/StartMenu.js